import { Outlet } from 'react-router';
import { useBreadcrumb } from '@/modules/ui/breadcrumbs/useBreadcrumb';

export function EntityLayout({ label, href }: { label: string; href?: string }) {
  useBreadcrumb({ label, href });
  return <Outlet />;
}
